import { Box } from "@mui/system";
import React, { useContext, useState } from "react";
import { LocalizationContext } from "../../lib/context";

type Props = {
  skills: any;
  setActiveSkill: any;
  containerStyle?: any;
  boxStyle?: any;
};

const Skills = ({
  skills,
  setActiveSkill,
  containerStyle,
  boxStyle,
}: Props) => {
  const { uiGeneral } = useContext(LocalizationContext).localeStrings;
  const [active, setActive] = useState("all");

  return (
    <>
      <Box className="skills" sx={containerStyle}>
        {Object.keys(skills)?.map((skill: string) => {
          const localizedSkillName =
            skill === "all"
              ? uiGeneral.all
              : uiGeneral.skills.filter((s) => {
                  return s.skillId === skill;
                })[0]?.name;
          return (
            <React.Fragment key={skill}>
              <Box
                sx={{
                  border: `${active === skill ? "2px" : "1px"} solid`,
                  borderColor: `${
                    active === skill ? "primary.light" : "textColors.light"
                  }`,
                  color: `${
                    active === skill ? "primary.light" : "textColors.main"
                  }`,
                  ...boxStyle,
                }}
                className="skill"
              >
                <span
                  onClick={() => {
                    setActiveSkill(skill);
                    setActive(skill);
                  }}
                  style={{ fontSize: "16px" }}
                >
                  {localizedSkillName?.toLowerCase()}
                </span>
              </Box>
            </React.Fragment>
          );
        })}
      </Box>
    </>
  );
};

export default Skills;
